import {
  CreateUserCommand,
  CurrentUserMetadata,
  TenantRoleDto,
  UpdateUserCommand,
  UserDto,
  UsersApi,
} from '@admin/app/api'
import { createApiClient } from '@admin/app/http-client'

export class UserService {
  private readonly httpClient = createApiClient(UsersApi)

  async load(): Promise<UserDto[]> {
    const { data } = await this.httpClient.usersGet()
    return data
  }

  async create(request: CreateUserCommand): Promise<UserDto> {
    const { data } = await this.httpClient.usersPost(request)
    return data
  }

  async update(request: UpdateUserCommand): Promise<UserDto> {
    const { data } = await this.httpClient.usersPut(request.userId, request)
    return data
  }

  async delete(userId: string): Promise<void> {
    await this.httpClient.usersDelete(userId)
  }

  async loadUserRoles(userId: string): Promise<TenantRoleDto[]> {
    const { data } = await this.httpClient.usersGetUserRoles(userId)
    return data
  }

  async updateUserRoles(userId: string, roleIds: number[]): Promise<void> {
    await this.httpClient.usersUpdateUserRoles(userId, { roleIds, userId })
  }

  async getUserMetadata(userId: string): Promise<CurrentUserMetadata> {
    const { data } = await this.httpClient.usersGetCurrentUserMetadata(userId)
    return data
  }
}

export const userService = new UserService()
